/**
 * HTTP statuses that mean the access token was rejected and the client should
 * refresh or end the session.
 *
 * Do not treat 403 as session expiry: this API uses 403 for business rules while
 * the user remains authenticated (e.g. contact request approve rules, chat
 * membership). Unauthenticated requests use 401 via {@code SecurityConfig}.
 */
export function isCredentialRejectedHttpStatus(status: number): boolean {
  return status === 401;
}
